import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.EduCourseOverview = class EduCourseOverview extends Snappy.BaseComponent {
    static get tagName() {
        return 'edu-course-overview';
    }

    constructor(element) {
        super(element);
    }

    setVars() {

    }

    setEventListeners() {

    }

    render() {
        this.setVars();
        this.setEventListeners();
        this.onSidebarFloating();
        this.onCourseAvailablity();
        this.onCustomScrollbar();
    }
    onCustomScrollbar() {
        if ($(window).width() < 960) {
            $("body .course-page__overview-sidebar").removeClass('mCustomScrollbar');
        }
    }
    onSidebarFloating() {
        $(function () {
            var offset = $("#sidebar").offset();
            var topPadding = 100;
            //var fixedBottom = $("footer");
            $(window).scroll(function () {
                $("#sidebar").show();
                if ($(window).scrollTop() + $(window).height() > $(document).height() - ($('.course-page__interested-section .fa-carousel.fa-carousel--edu-style').height() + $('footer').height())) {
                    $("#sidebar").hide();
                }
                if ($(window).scrollTop() + $(window).height() > $(document).height() - ($('.fa-footer').height() + 300)) {
                    $("#sidebar").hide();
                }
                if ($(window).scrollTop() > offset.top) {
                    $("#sidebar").stop().animate({
                        marginTop: $(window).scrollTop() - offset.top + topPadding
                    });
                } else {
                    $("#sidebar").stop().animate({
                        marginTop: 0
                    });
                };
            });
        });
    }

    onCourseAvailablity() {
        var courseAvail = $('.course-part').length;
        $('.course-part').hide();
        $('.course-part.static-course').show();
        $('.course-part:nth-child(2)').show();
        $('.course-part:nth-child(3)').show();
        $('#show-more-two').hide();
        $('#show-more').on('click', function () {
            if (courseAvail > 2) {
                $('.course-part').show();
                $('#show-more').hide();
                $('#show-more-two').show();
            }
        });
        $('#show-more-two').on('click', function () {
            if (courseAvail > 2) {
                $('.course-part').hide();
                $('.course-part:nth-child(2)').show();
                $('.course-part:nth-child(3)').show();
                $('#show-more-two').hide();
                $('#show-more').show();
            }
        });
    }

};



// WEBPACK FOOTER //
// ./components/edu-course-page/scripts/edu-course-page.js